import { ConfigPlugin } from "./config";

const LogPrefix = "Spindl SDK";

export type Logger = ReturnType<typeof createLoggerPlugin>;

export function createLoggerPlugin(configPlugin: ConfigPlugin) {
  function info(...args: any[]) {
    if (configPlugin.getConfig().debugMode) {
      console.log(`[${LogPrefix}]`, ...args);
    }
  }

  function warn(...args: any[]) {
    if (configPlugin.getConfig().debugMode) {
      console.warn(`[${LogPrefix}]`, ...args);
    }
  }

  function error(...args: any[]) {
    console.error(`[${LogPrefix}]`, ...args);
  }

  return {
    info,
    warn,
    error,
  };
}
